import { useEffect, useRef } from 'react'
import * as Sentry from '@sentry/electron/renderer'
import { GlobalEvents } from '@highlight/ipc'
import { APP_BADGE_SET_EVENT } from '@shared/app-badge'
import { useForYouUnreadCount } from '@renderer/overlay/hooks/use-for-you-unread-count'

/** Only the overlay publishes the Home unread count to the dock and taskbar. */
export function useAppBadgeSync(): void {
  const count = useForYouUnreadCount()
  const lastSentRef = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined' || window.__RENDERER_NAME !== 'overlay') {
      return
    }

    if (count === lastSentRef.current) {
      return
    }
    lastSentRef.current = count

    void GlobalEvents.invoke(APP_BADGE_SET_EVENT, count).catch((error) => {
      lastSentRef.current = null
      Sentry.captureException(error, {
        tags: { area: 'app-badge', operation: 'set' },
      })
    })
  }, [count])
}
